import {createAsyncThunk} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import CfgAttributeService from "../../api/cfgAttributeService";
import {CfgAttributesNames} from "../../util/constants";

export const getPartners =
    createAsyncThunk(`${SliceNames.PARTNER}/getPartners`,
        async (_, thunkAPI) => {
            try {
                const res = await CfgAttributeService.fetchAttributeValue(CfgAttributesNames.PARTNERS)
                return res.data
            } catch (e: any) {
                return thunkAPI.rejectWithValue(e)
            }
        })
